export default "__VITE_ASSET__CGLSqN08__"